import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../config/i18n";

export const FAQ = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="relative py-24 sm:py-32">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] font-semibold tracking-[0.3em] text-[#C5A059] uppercase mb-5">{t.faq.overline}</p>
          <h2 className="font-heading text-3xl sm:text-4xl text-[#F7F7F8] leading-snug mb-12">{t.faq.title}</h2>
        </Reveal>
        <div className="divide-y divide-[#22222B] border-y border-[#22222B]">
          {t.faq.items.map((item, i) => (
            <Reveal key={item.q} delay={i * 0.05}>
              <div>
                <button
                  data-testid={`faq-question-${i + 1}`}
                  onClick={() => setOpen(open === i ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 min-h-[56px] text-left group"
                >
                  <span className={`text-[15px] sm:text-base font-light transition-colors duration-300 ${open === i ? "text-[#D9A94A]" : "text-[#F7F7F8] group-hover:text-[#D9A94A]"}`}>
                    {item.q}
                  </span>
                  <Plus
                    size={18}
                    className={`shrink-0 text-[#C5A059] transition-transform duration-300 ${open === i ? "rotate-45" : ""}`}
                    strokeWidth={1.5}
                  />
                </button>
                <AnimatePresence initial={false}>
                  {open === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p data-testid={`faq-answer-${i + 1}`} className="pb-7 pr-10 text-sm sm:text-[15px] text-[#A3A3AF] leading-relaxed font-light">
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
